import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  tableCell: {
    width: '20%',
    minWidth: '150px',
  },
  breakWord: {
    width: '100%',
    wordBreak: 'break-all',
  },

  actionsIcon: {
    marginInlineStart: theme.spacing(1.5),
    color: '#7d8f9b',
    padding: theme.spacing(1),
  },
  progress: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  table: {
    border: '1px solid rgba(109,114,120,0.18)',
    borderRadius: 4,
  },
  tableHeader: {
    background: '#eef1f5',
    '& th': {
      borderBottom: '1px solid rgba(109,114,120,0.1)',
    },
  },
  newItemHint: {
    fontSize: 13,
    color: '#1b3958',
    fontWeight: 'normal',
    marginBottom: theme.spacing(2),
  },
  setDefaultButton: {
    padding: theme.spacing(1),
  },
  isDefaultIcon: {
    fontSize: 25,
    color: '#d1d8dc',
    '&.active': {
      color: '#508b46',
    },
  },
  copyIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: theme.spacing(1),
    marginTop: -2,
  },
}));
